define("media/templates/edit", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{perform this.closeModal}} @navigate={{if this.canNavigate this.navigate}} as |modal|>
  
    <modal.card @hasSecondary={{this.hasSecondary}} @portrait={{true}}>
      <div class="o--modal__mediaWrapper">
        {{#if this.mediaItem.videoUrl}}
          <Shared::Ui::Video
            @preload="auto"
            class="o--modal__media"
            height="640"
            id={{this.mediaItem.videoUrl}}
            poster={{this.mediaItem.imageUrl}}
            width="640"
          >
            <source src={{this.mediaItem.videoUrl}} type="video/mp4" />
          </Shared::Ui::Video>
  
        {{else}}
          <Shared::MediaItems::ModalDisplay @mediaItem={{this.mediaItem}} />
        {{/if}}
      </div>
  
      <modal.card-body class="u--p__tb__sm">
  
        <span class="u--text--sm u--float--right u--text--uppercase">
          {{t "media_library.uploaded"}}
          {{time-ago this.mediaItem.createdTime}}
        </span>
  
        {{#if this.editingCaption}}
          <div class="o--formWrapper u--m__b__sm">
            <label>{{svg-jar "media-note" class="o--icon u--m__r"}} {{t "calendar.modal.media_note"}}</label>
            <Textarea
              @value={{this.mediaItem.defaultCaption}}
              class="o--textareaCaption qa--mediaModal_notesInput"
              id="textareaMediaNote"
              placeholder={{t "calendar.modal.empty_media_note"}}
              {{autofocus}}
            />
          </div>
          <Shared::Post::Secondary::Toggle
            @class="cMT--toggle u--relative u--m__t__xs u--p__lr__0"
            @mediaItem={{this.mediaItem}}
            @postElementId={{this.uniqueId}}
            @toggleHashtagSuggestions={{this.toggleSmartHashtags}}
            @toggleSavedCaptions={{this.toggleCaptionTemplate}}
          />
          <div class="o--btnBar u--m__b u--text--right u--relative">
            <Shared::Ui::Button
              @class="qa--mediaModal_notesCloseBtn"
              @onClick={{perform this.cancelEditingCaption}}
              @variant="mute"
              type="button"
            >
              {{svg-jar "close" class="o--icon o--icon--light"}}
            </Shared::Ui::Button>
            <Shared::Ui::Button
              @onClick={{perform this.saveEditedCaption}}
              @text={{t "shared_words.update"}}
              type="button"
            />
          </div>
        {{else}}
          <div class="o--formWrapper">
            <label>
              {{svg-jar "media-note" class="o--icon u--m__r"}}
              {{t "calendar.modal.media_note"}}
            </label>
  
            <a
              class="u--m__l__sm u--text--sm u--text--uppercase qa--mediaModal_notesEdit"
              {{on "click" (set this "editingCaption" true)}}
            >
              {{t "shared_words.edit"}}
            </a>
            {{! This needs to be a single line, otherwise it causes an indent at the beginning of the media note }}
            {{! prettier-ignore}}
            <p class="o--textareaCaption--view u--p__l__lg qa--mediaModal_notesInput">{{this.mediaItem.defaultCaption}}</p>
          </div>
        {{/if}}
  
        {{#if this.canEditLabel}}
          <div class="o--formWrapper">
            <Media::LabelMedia
              @addNewLabel={{this.addNewLabel}}
              @deleteLabel={{this.deleteLabel}}
              @groupLabels={{this.groupLabels}}
              @location="media library"
              @mediaItem={{this.mediaItem}}
            />
          </div>
        {{/if}}
  
      </modal.card-body>
  
      <modal.card-footer>
        <div class="o--btnBar u--float--left">
  
          {{#if this.canDestroyMedia}}
            <button
              class="o--btn u--text--light"
              disabled={{this.mediaItem.isSaving}}
              type="button"
              {{on "click" (perform this.deleteMediaItem)}}
            >
              <span>
                {{svg-jar "trash" class="o--icon o--icon--light"}}
                <EmberTooltip @delay={{330}} @side="top">
                  {{t "media_library.delete_media"}}
                </EmberTooltip>
              </span>
            </button>
          {{/if}}
  
          <a class="o--btn u--text--light" {{on "click" this.toggleStarred}}>
            <span>
              {{#if this.mediaItem.isStarred}}
                {{svg-jar "starred" class="o--icon o--icon--yellow"}}
              {{else}}
                {{svg-jar "star" class="o--icon o--icon--light"}}
              {{/if}}
              <EmberTooltip @delay={{330}} @side="top">
                {{t "media_library.star_media"}}
              </EmberTooltip>
            </span>
          </a>
  
        </div>
  
        <div class="o--btnBar u--float--right">
          {{#unless this.currentGroup.contributor}}
            <LinkToExternal
              @model={{this.mediaItem}}
              @route="calendarMedia"
              class="o--btn o--btn--outline u--text--light"
            >
              {{t "media_library.view_on_calendar"}}
            </LinkToExternal>
          {{/unless}}
        </div>
      </modal.card-footer>
  
      <Shared::Post::Secondary::Wrapper
        @hasDirtyAttributes={{this.hasDirtyAttributes}}
        @location="media_item"
        @mediaItem={{this.mediaItem}}
        @post={{@post}}
        @postElementId={{this.uniqueId}}
        @rollbackSavedCaption={{perform this.rollbackSavedCaption}}
        @savedCaptionToEdit={{this.savedCaptionToEdit}}
        @setCaptionToEdit={{set this "savedCaptionToEdit"}}
        @socialProfile={{this.socialProfile}}
        @toggleSecondary={{this.toggleSecondary}}
      />
    </modal.card>
  
    {{#if this.mediaItem.hasPosts}}
      <modal.card
        @closeIcon={{false}}
        @hasSecondary={{this.hasSecondary}}
        @portrait={{true}}
        {{did-insert (perform this.mediaItem.fetchVisiblePosts)}}
      >
        <modal.card-body>
          <table class="o--table o--table--condensed o--table--hover u--m__b__0">
            <thead>
              <tr>
                <th class="u--text--left">
                  {{t "calendar.modal.media_used_in"}}
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {{#each this.mediaItem.visiblePosts as |post|}}
                <Shared::MediaItems::PostCard @editPost={{this.editGram}} @post={{post}} />
              {{/each}}
            </tbody>
          </table>
        </modal.card-body>
      </modal.card>
    {{/if}}
  
  </Shared::Modal>
  {{outlet}}
  */
  {
    "id": "dR1TQhjT",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@navigate\"],[[28,[37,1],[[30,0,[\"closeModal\"]]],null],[52,[30,0,[\"canNavigate\"]],[30,0,[\"navigate\"]]]]],[[\"default\"],[[[[1,\"\\n\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@hasSecondary\",\"@portrait\"],[[30,0,[\"hasSecondary\"]],true]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"o--modal__mediaWrapper\"],[12],[1,\"\\n\"],[41,[30,0,[\"mediaItem\",\"videoUrl\"]],[[[1,\"        \"],[8,[39,3],[[24,0,\"o--modal__media\"],[24,\"height\",\"640\"],[16,1,[30,0,[\"mediaItem\",\"videoUrl\"]]],[16,\"poster\",[30,0,[\"mediaItem\",\"imageUrl\"]]],[24,\"width\",\"640\"]],[[\"@preload\"],[\"auto\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,\"source\"],[15,\"src\",[30,0,[\"mediaItem\",\"videoUrl\"]]],[14,4,\"video/mp4\"],[12],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n\"]],[]],[[[1,\"        \"],[8,[39,4],null,[[\"@mediaItem\"],[[30,0,[\"mediaItem\"]]]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__tb__sm\"]],null,[[\"default\"],[[[[1,\"\\n\\n      \"],[10,1],[14,0,\"u--text--sm u--float--right u--text--uppercase\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"media_library.uploaded\"],null]],[1,\"\\n        \"],[1,[28,[35,6],[[30,0,[\"mediaItem\",\"createdTime\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"editingCaption\"]],[[[1,\"        \"],[10,0],[14,0,\"o--formWrapper u--m__b__sm\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,[28,[35,7],[\"media-note\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\" \"],[1,[28,[35,5],[\"calendar.modal.media_note\"],null]],[13],[1,\"\\n          \"],[8,[39,8],[[24,0,\"o--textareaCaption qa--mediaModal_notesInput\"],[24,1,\"textareaMediaNote\"],[16,\"placeholder\",[28,[37,5],[\"calendar.modal.empty_media_note\"],null]],[4,[38,9],null,null]],[[\"@value\"],[[30,0,[\"mediaItem\",\"defaultCaption\"]]]],null],[1,\"        \"],[13],[1,\"\\n        \"],[8,[39,10],null,[[\"@class\",\"@mediaItem\",\"@postElementId\",\"@toggleHashtagSuggestions\",\"@toggleSavedCaptions\"],[\"cMT--toggle u--relative u--m__t__xs u--p__lr__0\",[30,0,[\"mediaItem\"]],[30,0,[\"uniqueId\"]],[30,0,[\"toggleSmartHashtags\"]],[30,0,[\"toggleCaptionTemplate\"]]]],null],[1,\"\\n        \"],[10,0],[14,0,\"o--btnBar u--m__b u--text--right u--relative\"],[12],[1,\"\\n          \"],[8,[39,11],[[24,4,\"button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"qa--mediaModal_notesCloseBtn\",[28,[37,1],[[30,0,[\"cancelEditingCaption\"]]],null],\"mute\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,7],[\"close\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[8,[39,11],[[24,4,\"button\"]],[[\"@onClick\",\"@text\"],[[28,[37,1],[[30,0,[\"saveEditedCaption\"]]],null],[28,[37,5],[\"shared_words.update\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,\"\\n            \"],[1,[28,[35,7],[\"media-note\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n            \"],[1,[28,[35,5],[\"calendar.modal.media_note\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[11,3],[24,0,\"u--m__l__sm u--text--sm u--text--uppercase qa--mediaModal_notesEdit\"],[4,[38,12],[\"click\",[28,[37,13],[[30,0],\"editingCaption\",true],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"shared_words.edit\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"],[1,\"          \"],[10,2],[14,0,\"o--textareaCaption--view u--p__l__lg qa--mediaModal_notesInput\"],[12],[1,[30,0,[\"mediaItem\",\"defaultCaption\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,0,[\"canEditLabel\"]],[[[1,\"        \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n          \"],[8,[39,14],null,[[\"@addNewLabel\",\"@deleteLabel\",\"@groupLabels\",\"@location\",\"@mediaItem\"],[[30,0,[\"addNewLabel\"]],[30,0,[\"deleteLabel\"]],[30,0,[\"groupLabels\"]],\"media library\",[30,0,[\"mediaItem\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar u--float--left\"],[12],[1,\"\\n\\n\"],[41,[30,0,[\"canDestroyMedia\"]],[[[1,\"          \"],[11,\"button\"],[24,0,\"o--btn u--text--light\"],[16,\"disabled\",[30,0,[\"mediaItem\",\"isSaving\"]]],[24,4,\"button\"],[4,[38,12],[\"click\",[28,[37,1],[[30,0,[\"deleteMediaItem\"]]],null]],null],[12],[1,\"\\n            \"],[10,1],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"trash\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n              \"],[8,[39,15],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,5],[\"media_library.delete_media\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[11,3],[24,0,\"o--btn u--text--light\"],[4,[38,12],[\"click\",[30,0,[\"toggleStarred\"]]],null],[12],[1,\"\\n          \"],[10,1],[12],[1,\"\\n\"],[41,[30,0,[\"mediaItem\",\"isStarred\"]],[[[1,\"              \"],[1,[28,[35,7],[\"starred\"],[[\"class\"],[\"o--icon o--icon--yellow\"]]]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,7],[\"star\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n\"]],[]]],[1,\"            \"],[8,[39,15],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,5],[\"media_library.star_media\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"currentGroup\",\"contributor\"]]],[[[1,\"          \"],[8,[39,17],[[24,0,\"o--btn o--btn--outline u--text--light\"]],[[\"@model\",\"@route\"],[[30,0,[\"mediaItem\"]],\"calendarMedia\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,5],[\"media_library.view_on_calendar\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,18],null,[[\"@hasDirtyAttributes\",\"@location\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@rollbackSavedCaption\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@socialProfile\",\"@toggleSecondary\"],[[30,0,[\"hasDirtyAttributes\"]],\"media_item\",[30,0,[\"mediaItem\"]],[30,2],[30,0,[\"uniqueId\"]],[28,[37,1],[[30,0,[\"rollbackSavedCaption\"]]],null],[30,0,[\"savedCaptionToEdit\"]],[28,[37,13],[[30,0],\"savedCaptionToEdit\"],null],[30,0,[\"socialProfile\"]],[30,0,[\"toggleSecondary\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"mediaItem\",\"hasPosts\"]],[[[1,\"    \"],[8,[30,1,[\"card\"]],[[4,[38,19],[[28,[37,1],[[30,0,[\"mediaItem\",\"fetchVisiblePosts\"]]],null]],null]],[[\"@closeIcon\",\"@hasSecondary\",\"@portrait\"],[false,[30,0,[\"hasSecondary\"]],true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"table\"],[14,0,\"o--table o--table--condensed o--table--hover u--m__b__0\"],[12],[1,\"\\n          \"],[10,\"thead\"],[12],[1,\"\\n            \"],[10,\"tr\"],[12],[1,\"\\n              \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"calendar.modal.media_used_in\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"th\"],[12],[13],[1,\"\\n              \"],[10,\"th\"],[12],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,21],[[28,[37,21],[[30,0,[\"mediaItem\",\"visiblePosts\"]]],null]],null],null,[[[1,\"              \"],[8,[39,22],null,[[\"@editPost\",\"@post\"],[[30,0,[\"editGram\"]],[30,3]]],null],[1,\"\\n\"]],[3]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"]],[1]]]]],[1,\"\\n\"],[46,[28,[37,24],null,null],null,null,null]],[\"modal\",\"@post\",\"post\"],false,[\"shared/modal\",\"perform\",\"if\",\"shared/ui/video\",\"shared/media-items/modal-display\",\"t\",\"time-ago\",\"svg-jar\",\"textarea\",\"autofocus\",\"shared/post/secondary/toggle\",\"shared/ui/button\",\"on\",\"set\",\"media/label-media\",\"ember-tooltip\",\"unless\",\"link-to-external\",\"shared/post/secondary/wrapper\",\"did-insert\",\"each\",\"-track-array\",\"shared/media-items/post-card\",\"component\",\"-outlet\"]]",
    "moduleName": "media/templates/edit.hbs",
    "isStrictMode": false
  });
});